import { useEffect } from 'react';
import { SetCount } from '../types';

/**
 * Utility hook to manage the count shown in search page footer
 */
export const useCount = ({ count = 0, setCount }: { count?: number; setCount: SetCount }) => {
  useEffect(() => {
    if (setCount) {
      setCount(count);
    }

    return () => setCount(0);
  }, [count, setCount]);
};
